import { render } from "./SectionDropdownV2.vue?vue&type=template&id=7c137fc0"
import script from "./SectionDropdownV2.vue?vue&type=script&lang=js"
export * from "./SectionDropdownV2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__